// extracted by mini-css-extract-plugin
export default {"tributes__info":"styles_tributes__info__etiwV","tributes__img":"styles_tributes__img__CWY34","tributes__title":"styles_tributes__title__+Phlp"};